import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
    Copyright &copy; 2020
  </footer>
    )
}

export default Footer
